import { H } from 'components';
import Prac01 from './Prac01';
import Prac02 from './Prac02';
import Prac03 from './Prac03';
import Prac04 from './Prac04';
import Prac05 from './Prac05';
import Prac06 from './Prac06';
import Prac07 from './Prac07';
import Prac08 from './Prac08';
import Prac09 from './Prac09';
import Prac10 from './Prac10';
import Task01 from './Task01';
import Task02 from './Task02';
import Task03 from './Task03';
import Task04 from './Task04';
import Task05 from './Task05';
import Task06 from './Task06';
import Task07 from './Task07';
import Task08 from './Task08';
import Task09 from './Task09';

const tasks = [
  {
    title: <H level={2}>prac 01: reacting to input with state</H>,
    task: <Prac01 />,
  },
  {
    title: <H level={2}>prac 02: mocking up from</H>,
    task: <Prac02 />,
  },
  {
    title: <H level={2}>prac 03: “living styleguides” or “storybooks”</H>,
    task: <Prac03 />,
  },
  {
    title: <H level={2}>task 01: add and remove a css class</H>,
    task: <Task01 />,
  },
  {
    title: <H level={2}>task 02: profile editor</H>,
    task: <Task02 />,
  },
  {
    title: <H level={2}>task 03: profile editor without react</H>,
    task: <Task03 />,
  },
  {
    title: <H level={2}>prac 04: redundant state</H>,
    task: <Prac04 />,
  },
  {
    title: <H level={2}>prac 05: group related state</H>,
    task: <Prac05 />,
  },
  {
    title: <H level={2}>prac 06: avoid contradictions in state</H>,
    task: <Prac06 />,
  },
  {
    title: <H level={2}>prac 07: avoid dublication in state</H>,
    task: <Prac07 />,
  },
  {
    title: <H level={2}>prac 08: avoid deeply nested state</H>,
    task: <Prac08 />,
  },
  {
    title: <H level={2}>prac 09: avoid deeply nested state</H>,
    task: <Prac09 />,
  },
  {
    title: <H level={2}>prac 10: avoid deeply nested state (using immer)</H>,
    task: <Prac10 />,
  },
  {
    title: <H level={2}>task 04: fix a component that's not updating</H>,
    task: <Task04 />,
  },
  {
    title: <H level={2}>task 05: fix a brocken packing list</H>,
    task: <Task05 />,
  },
  {
    title: <H level={2}>task 06: fix the disappearing selection</H>,
    task: <Task06 />,
  },
  {
    title: <H level={2}>task 07: impliment multiple selection</H>,
    task: <Task07 />,
  },
  {
    title: <H level={2}>task 08: impliment multiple selection (alternate)</H>,
    task: <Task08 />,
  },
  {
    title: <H level={2}>task 09: impliment multiple selection (alternate)</H>,
    task: <Task09 />,
  },
];

export { tasks };
